import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaSpacing } from 'yoda-ui/yodaTheme';

export const mayaLayoutStyle: SxProps<Theme> = {
  width: '100vw',
  marginBottom: -YodaSpacing.xLarge,
  flexGrow: 1,
};

export const mayaLayoutContentStyle: SxProps<Theme> = {
  position: 'relative',
  flex: 3,
  padding: YodaSpacing.xxLarge,
  paddingBottom: YodaSpacing.xxxxLarge,
  backgroundColor: YodaColors.blue1,
  width: '100%',
  boxSizing: 'border-box',
};
